<template>
  <v-dialog v-model="dialog" persistent max-width="425px">
    <template v-slot:activator="{ on, attrs }">
      <v-btn color="pink" x-small v-bind="attrs" v-on="on" dark fab>
        <v-icon small="small">mdi-plus</v-icon>
      </v-btn>
    </template>
    <v-card grid-list-md>
      <ModelTitle title="Add Card" @close="cancel()" />
      <v-container grid-list-lg class="pt-0">

        <CreditCard v-if="dialog" @submit="paymentCollected" :donor="donor" @cancel="cancel" />

        <v-card-actions>
          <v-btn @click="submit" :loading="loading" color="primary" width="150" block large>Submit</v-btn>
        </v-card-actions>
      </v-container>

    </v-card>
  </v-dialog>
</template>
<!-- <script src="https://js.stripe.com/v3/"></script> -->
<!-- <script src="../../../../plugins/card.js" onload="fileLoaded()"></script> -->
<script>


// import customerService from "@/modules/Customer/service.js";
import CreditCard from '@/modules/PaymentMethod/components/CreditCard.vue'

export default {
  name: "donor-payment-method-collection",
  props: ['donor'],
  data() {
    return {
      dialog: false,
      loading: false,
    };
  },
  components: {
    CreditCard,
  },
  methods: {
    cancel() {
      this.$events.emit("closeCreditCard");
      this.dialog = false
    },
    submit() {
      this.$events.emit("submitCreditCard");
    },
    paymentCollected() {
      this.$emit('submit')
      this.dialog = !this.dialog
    },
  },
};
</script>

<style scoped></style>